// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'

/** Yes/no cell for whether a member has a sign-in requirement. */
export function RequirementIndicator({ required }: { required: boolean }) {
  const { t } = useTranslation('settings')
  return required
    ? <span className="badge bg-success bg-opacity-10 text-success">{t('shared.common.yes')}</span>
    : <span className="text-secondary">{t('shared.common.no')}</span>
}
